// source: giftcard_product.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.grpc.api.v1.GiftcardProduct', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.api.v1.GiftcardProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.grpc.api.v1.GiftcardProduct.repeatedFields_, null);
};
goog.inherits(proto.grpc.api.v1.GiftcardProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.api.v1.GiftcardProduct.displayName = 'proto.grpc.api.v1.GiftcardProduct';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.grpc.api.v1.GiftcardProduct.repeatedFields_ = [13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.grpc.api.v1.GiftcardProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.grpc.api.v1.GiftcardProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.api.v1.GiftcardProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    backgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    serviceId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    locale: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    color: jspb.Message.getFieldWithDefault(msg, 9, ""),
    expirePeriodInMonths: jspb.Message.getFieldWithDefault(msg, 10, 0),
    showLogo: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    footerText: jspb.Message.getFieldWithDefault(msg, 12, ""),
    pricesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    feesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    currency: jspb.Message.getFieldWithDefault(msg, 15, ""),
    paymentAccountConfigured: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    paymentAccountActive: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.api.v1.GiftcardProduct}
 */
proto.grpc.api.v1.GiftcardProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.grpc.api.v1.GiftcardProduct;
  return proto.grpc.api.v1.GiftcardProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.api.v1.GiftcardProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.api.v1.GiftcardProduct}
 */
proto.grpc.api.v1.GiftcardProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundImageUrl(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setServiceId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpirePeriodInMonths(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowLogo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFooterText(value);
      break;
    case 13:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPrices(values[i]);
      }
      break;
    case 14:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFees(values[i]);
      }
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentAccountConfigured(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentAccountActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.grpc.api.v1.GiftcardProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.api.v1.GiftcardProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.api.v1.GiftcardProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getServiceId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExpirePeriodInMonths();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getShowLogo();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getFooterText();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      13,
      f
    );
  }
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      14,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPaymentAccountConfigured();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getPaymentAccountActive();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string background_image_url = 5;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 service_id = 6;
 * @return {number}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string locale = 7;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_active = 8;
 * @return {boolean}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string color = 9;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 expire_period_in_months = 10;
 * @return {number}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getExpirePeriodInMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setExpirePeriodInMonths = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool show_logo = 11;
 * @return {boolean}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getShowLogo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setShowLogo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string footer_text = 12;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getFooterText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setFooterText = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated int64 prices = 13;
 * @return {!Array<number>}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getPricesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setPricesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.addPrices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};


/**
 * repeated int64 fees = 14;
 * @return {!Array<number>}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getFeesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setFeesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.addFees = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};


/**
 * optional string currency = 15;
 * @return {string}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool payment_account_configured = 16;
 * @return {boolean}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getPaymentAccountConfigured = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setPaymentAccountConfigured = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool payment_account_active = 17;
 * @return {boolean}
 */
proto.grpc.api.v1.GiftcardProduct.prototype.getPaymentAccountActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.grpc.api.v1.GiftcardProduct} returns this
 */
proto.grpc.api.v1.GiftcardProduct.prototype.setPaymentAccountActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


goog.object.extend(exports, proto.grpc.api.v1);
